import axios from './request'
import { prop } from 'ramda'

/**
 * @typedef Rule
 * @property {string|string[]} action
 * @property {string|string[]?} subject
 * @property {string|string[]?} fields An array of fields to which user has (or not) access
 * @property {any?} conditions An object of conditions which restricts the rule scope
 * @property {string?} inverted Indicates whether rule allows or forbids something
 * @property {string?} reason Message which explains why rule is forbidden
 */

/**
 *
 * @returns {Promise<Rule[]>}
 */
export default function getUserRules() {
	return axios.get('/api/User/getCrmRights/')
		.then(({ data }) => data)
		.then(prop('data'))
}
